import apiResponse from '@stores/ApiResponse';
import {
  PublishQuestionnaireResult,
  QuestionnaireAdminStore,
  QuestionnaireFormDefinition,
} from '@stores/QuestionnaireAdminStore';
import actionResponse, { ActionResponse } from '@actions/ActionResponse';
import { cleanForPublish } from '@app/components/Admin/Questionnaires/questionnaireDefinitionEditing';
import { questionnaireActionError } from './questionnaireActionError';

/**
 * Publishes a questionnaire definition. The result is the PublishQuestionnaireResult. On failure the status message
 * is the server's explanation, e.g. "Item PHQ4_1 needs text", so the editor can show it.
 */
export class PublishQuestionnaireAction {
  constructor(private readonly store: QuestionnaireAdminStore = new QuestionnaireAdminStore()) {}

  public async Execute(definition: QuestionnaireFormDefinition): Promise<ActionResponse> {
    try {
      const result = await apiResponse.handleApiResponse<PublishQuestionnaireResult>(() =>
        this.store.Publish(cleanForPublish(definition))
      );
      return actionResponse.Success(
        result.changed ? `Published version ${result.version}` : 'Nothing changed, so no new version was published',
        result
      );
    } catch (err) {
      return questionnaireActionError(err);
    }
  }
}
